module.exports = __webpack_public_path__ + "img/HZGB06-60W.80cace9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB06-60W.png
// module id = EGl8
// module chunks = 0